<span [matTooltip]="params.toolTip">
  {{ this.params.value }}
  <i *ngIf="showFlag" [style.color]="flagColor" class="mg-l-s fa-sharp fa-thin fa-lg {{flagIcon}}"></i>
</span>
